var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.47,
  d: "M13.125 18.875v-7A.875.875 0 0 0 12.25 11h-3.5a.875.875 0 0 0-.875.875v7M2.625 9.25a1.75 1.75 0 0 1 .62-1.337l6.125-5.25a1.75 1.75 0 0 1 2.26 0l6.125 5.25a1.75 1.75 0 0 1 .62 1.337v7.875a1.75 1.75 0 0 1-1.75 1.75H4.375a1.75 1.75 0 0 1-1.75-1.75z"
})));
export default SvgHome;